export enum AffectedMaterial {
  CONFIG_RAL_PRIMARY = 'config_ral_primary',
  CONFIG_RAL_SECONDARY = 'config_ral_secondary',
}

export interface Color {
  externalId: string;
  affectedMaterial: AffectedMaterial;
  possibleColorValues: string[];
  localisedName: string;
}
